import styled from 'styled-components';

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 1.1rem;
`;

export const Label = styled.label`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: ${({ theme }) => theme.colors.textMuted};
`;

const controlStyles = `
  min-height: 44px;
  padding: 0.7em 1em;
  border-radius: 2px;
  border: 1px solid rgba(29, 27, 23, 0.2);
  background: #ffffff;
  color: inherit;
  font-size: 1rem;
  transition: border-color 200ms ease, box-shadow 200ms ease;
`;

export const Input = styled.input`
  ${controlStyles}

  &::placeholder {
    color: ${({ theme }) => theme.colors.textFaint};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.text};
    box-shadow: 0 2px 0 0 ${({ theme }) => theme.colors.gold};
  }
`;

export const Textarea = styled.textarea`
  ${controlStyles}
  min-height: 100px;
  resize: vertical;
  font-family: inherit;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textFaint};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.text};
    box-shadow: 0 2px 0 0 ${({ theme }) => theme.colors.gold};
  }
`;

export const Select = styled.select`
  ${controlStyles}
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.text};
    box-shadow: 0 2px 0 0 ${({ theme }) => theme.colors.gold};
  }
`;

export const HelperText = styled.span`
  font-size: 0.78rem;
  color: ${({ theme }) => theme.colors.textFaint};
`;
